import { render } from "./newEnduit.vue?vue&type=template&id=083e88c2"
import script from "./newEnduit.vue?vue&type=script&lang=js"
export * from "./newEnduit.vue?vue&type=script&lang=js"

import "./newEnduit.vue?vue&type=style&index=0&id=083e88c2&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__